<div>
  <h3>{{text}}</h3>
  <p style="white-space: pre-line">{{body}}</p>

  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex></div>
    <div>
      <button (click)="confirm()" mat-raised-button color="warn"><span> Ok</span></button>
    </div>
  </div>
</div>
